import ImplantExpiry from "./ImplantVerification";

const ImplantExpiryPage = () => {
    return (
        <ImplantExpiry />
    );
}

export default ImplantExpiryPage;